import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.css'
})
export class PublicLayoutComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    // You can add any initialization logic here if needed
  }

  // This method can be used to navigate to a specific route programmatically
  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  shouldShowBackground(): boolean {
    // Add logic to determine when to show background
    // For example, only show on certain routes
    return true; // or implement route-based logic
  }

}
